import { useTranslation } from 'react-i18next';

import { useAllTiles } from './data';
import Card from '../../../../shared/Card';
import Placeholder from '../../../../shared/Placeholder';
import Table from '../../../../shared/Table/Table.jsx';
import { columns, engagementBodyData } from './allTilesTableData.jsx';
import { useTileStatusTabs } from '../../hooks/useTileStatusTabs';

const EngagementByTile = ({
  sortingStatus,
  changeSort,
  showAll,
  setShowAll,
  campaignId,
}) => {
  const {
    activeTab,
    tileStatus,
    page,
    tabs,
    setPage,
    handleTabClick,
  } = useTileStatusTabs('engagement');
  const itemsPerPage = 20;
  const onPageChange = data => setPage(data.selected + 1);
  const { t } = useTranslation('reports');

  const { isLoading, data = { data: [], pagy: {} } } = useAllTiles({
    page,
    itemsPerPage,
    tileStatus,
    showAll,
    campaignId,
    ...sortingStatus,
  });

  const { pagy } = data;

  return (
    <Card
      items={!showAll ? itemsPerPage : undefined}
      pagy={!showAll ? pagy : undefined}
      onPageChange={!showAll ? onPageChange : undefined}
      title={t('engagementTable.tableTitle')}
      titleTooltip={t('engagementTable.tableTitleTooltip')}
      onClick={setShowAll}
      canShowAll={true}
      isShowingAll={showAll}
      isLoading={isLoading}
      className="engagement-section"
      tabs={tabs}
      activeTab={activeTab}
      tabClick={handleTabClick}
      margin="0"
    >
      {data.data.length ? (
        <Table
          columns={columns}
          body={engagementBodyData(data.data)}
          sortingStatus={sortingStatus}
          changeSort={changeSort}
          minWidthBeforeScroll="1290px"
          id="engagement-table"
        />
      ) : (
        <Placeholder />
      )}
    </Card>
  );
};

export default EngagementByTile;
